import React, { useEffect, useRef, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Radio, RadioGroup, FormControlLabel, FormLabel, FormHelperText, Autocomplete
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { QuotationMaster } from '../TitleList';
import styled, { inputImages, inputStyles, inputNumber, inputNumbers, inputStyless } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import PreviewIcon from '@mui/icons-material/Preview';
import { errorStyles } from '../../Utils/table';
import CircularProgress from '@mui/material/CircularProgress';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData, fetchItemMaterialData } from '../../Store/PHPSlice/Item';
import { fetchSchoolData } from '../../Store/PHPSlice/School';
import { selectCloths,selectSalesman,selectGr,selectBrandlist, selectFirm, selectItemAvg, selectItemMaterialData, selectItems, selectJobRate, selectParty, selectPriPerGrp, selectQuotationNo, selectQuotNo, selectSchool } from '../Selectors/Master/ItemSelectors';
import { fetchPricePerData } from '../../Store/PHPSlice/Sale/PricePercent';
import { fetchSalesmanData } from '../../Store/PHPSlice/Salesman';
import { fetchGrData } from '../../Store/PHPSlice/Guaranteer';
import { fetchBrandData } from '../../Store/PHPSlice/Rack';
import { createQuotationEntry, fetchQuotationNo, fetchQuotNo } from '../../Store/PHPSlice/Sale/Quotation';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { useNavigation } from '../NavigationContext';
import { fetchJobRateData } from '../../Store/PHPSlice/JobRate';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { selectPatternMatchReg, selectRetailerReg } from '../Selectors/Master/OutwardSelectors';
import { fetchPatternMatchingReg } from '../../Store/PHPSlice/Pattern/PatternMatching';
import { Preview } from '@mui/icons-material';
import axios from 'axios';
import { fetchRetailerReg } from '../../Store/PHPSlice/retailerAPi';


const QuotEntry2 = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        firm: '',
        emb: '',
        logo: '',
        quotType: '0',
        salesmanId:'',
        grId:'',
        brandId:'',
        quotNo: '',
        quotationNo: '',
        partyId: '',
        priceList: '',
        item: '',
        schl: '',
        jobrate: '',
        extra: '0',
        outSrc: '0',
        naration: '-',
        agegroup:'',
        size: '',
        match: '',
        profit: '0',
        loss: '0',
        avgType: '0',
        oldjobrate: '0',
        scrTomil: '0',
        milToparty: '0',
        retailerId: '',
        scrPer: "",
        mrpPer: "",
        milPer: "",
        retailerPer: "",
        groupId: "",
        userId: userdata?.ID
    });
    const [formArray, setFormArray] = useState([]);
    const [formCopy, setFormCopy] = useState({
        firmNm: '',
        partyNm: '',
        priceNm: '',
        itemNm: '',
        schlNm: '',
        mrp: '',
        firm: ''
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        schl: fetchSchoolData,
        item: fetchItemData,
        partyId: fetchPartyData,
        cloth: fetchClothData,
        patMatch: fetchPatternMatchingReg,
        retailerId: fetchRetailerReg
        // Add more mappings if needed
    };
    const [errors, setErrors] = useState({});
    const [clothdata, setClothdata] = useState([]);
    const [m1clothdata, setM1Clothdata] = useState([]);
    const [m2clothdata, setM2Clothdata] = useState([]);
    const [m3clothdata, setM3Clothdata] = useState([]);
    const [matching, setMatching] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const clothTypes = ['Main Cloth', 'Matching Cloth-1', 'Matching Cloth-2', 'Matching Cloth-3'];
    const [rows, setRows] = useState([
        { clothTypes: 'Main Cloth', cloth: '0', rate: '0', panna: '0' }
    ]);

    const [patternMatch, setPatternMatch] = useState([]);
    const [jobrate, setJobrate] = useState({
        ctinex: '',
        ctoutex: '',
        stinex: '',
        stoutex: '',
        kjinex: '',
        kjoutex: '',
        prinex: '',
        proutex: '',
        mtex: '',
        extex: '',
        totex: '',
        cut_to_pack_ex: '',
        stitch_to_pack_ex: '',
        embriadaryex: '',
        printex: '',
        screenex: ''
    });
    const [selectedMaterials, setSelectedMaterials] = useState([]);
    const [itemMaterials, setItemMaterials] = useState([]);


    const isDesktop = useMediaQuery('(min-width:768px)');
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const quotationNoRef = useRef(null);
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const itemlist = useSelector(selectItems);
    const schlList = useSelector(selectSchool);
    const pricelist = useSelector(selectPriPerGrp);
    const quotNo = useSelector(selectQuotNo);
    const quotationNo = useSelector(selectQuotationNo);
    const clothlist = useSelector(selectCloths);
    const jobratelist = useSelector(selectJobRate);
    const itemAvglist = useSelector(selectItemAvg);

    const patmatchlist = useSelector(selectPatternMatchReg);
    const retailerlist = useSelector(selectRetailerReg);
    const salesmanlist = useSelector(selectSalesman);
    const grlist = useSelector(selectGr);
    const brandlist = useSelector(selectBrandlist);

    //item-material data
    const itemMaterialdata = useSelector(selectItemMaterialData);
    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchItemData());
        dispatch(fetchSchoolData());
        dispatch(fetchPricePerData());
        // dispatch(fetchQuotNo());
        dispatch(fetchQuotationNo());
        dispatch(fetchClothData());
        dispatch(fetchJobRateData());
        dispatch(fetchItemAvgData());
        dispatch(fetchRetailerReg());
        dispatch(fetchPatternMatchingReg());
        dispatch(fetchSalesmanData());
        dispatch(fetchGrData());
        dispatch(fetchBrandData());
        // Object.keys(openDropdowns).forEach((dropdown) => {
        //     if (openDropdowns[dropdown]) {
        //         const action = actionMap[dropdown];
        //         if (action) {
        //             dispatch(action());
        //         }
        //     }
        // });
    }, [dispatch]);
    useEffect(() => {
        if (formData.quotType === "0") {
            dispatch(fetchQuotNo());
        }
    }, [formData.quotType, dispatch]);
    useEffect(() => {
        if (quotNo.data) {
            const val = quotNo?.data?.quotNo;
            setFormData(prevData => ({
                ...prevData,
                quotNo: val
            }))
        }
        if (quotationNo.data) {
            const item = quotationNo?.data?.quotationNo;
            setFormData(prevFormData => ({
                ...prevFormData,
                quotationNo: item
            }))
        }
    }, [quotNo, quotationNo]);

    useEffect(() => {
        if (itemMaterialdata?.data?.length > 0) {
            setItemMaterials(itemMaterialdata?.data);
        }
    }, [itemMaterialdata]);

    useEffect(() => {
        return () => {
            localStorage.removeItem("viewFormData");
        };
    }, []);


    const fetchItemJobRate = async (id) => {
        const result = await axios.get(`${baseUrl}?apicall=getJobRatelist&itemId=${id}`);
        // console.log(result?.data);
        const item = result?.data?.data;
        setJobrate(prev => ({
            ...prev,
            cut_in: item.cut_in,
            cut_out: item.cut_out,
            stitch_in: item.stitch_in,
            stitch_out: item.stitch_out,
            kaje_in: item.kaje_in,
            kaje_out: item.kaje_out,
            press_in: item.press_in,
            press_out: item.press_out,
            material: item.material,
            extra: item.extra,
            total: item.total,
            cut_to_pack: item.cut_to_pack,
            stitch_to_pack: item.stitch_to_pack,
            embriadary: item.embriadary,
            screen: item.screen,
            print: item.print,

        }));
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        if (name === 'quotType' && value === '1') {
            setFormData(prev => ({
                ...prev,
                quotationNo: ''
            }));
        } else {
            if (quotationNo.data) {
                const item = quotationNo.data.quotationNo;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    quotationNo: quotationNo.data.quotationNo
                }))
            }
        }
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        const updateFormData = (updates) => {
            setFormData(prev => ({
                ...prev,
                ...updates
            }));
        };

        const updateFormCopy = (key, value) => {
            setFormCopy(prev => ({
                ...prev,
                [key]: value
            }));
        };

        switch (dropdownType) {
            case 'item':
                if (value) {
                    dispatch(fetchItemMaterialData(value));
                    // const selectJobRate = jobratelist.data.find(val => val.itemId === value);
                    const selectJobRate = jobratelist?.data?.find?.(val => val.itemId === value) || '';
                    const selectedSize = itemlist?.data?.find(val => val.ID === value);

                    updateFormCopy('itemNm', selectedSize.itemNm);

                    const updates = selectJobRate ? {
                        jobrate: selectJobRate.total,
                        size: selectedSize.size,
                        oldjobrate: selectJobRate.total
                    } : {
                        jobrate: '',
                        size: selectedSize.size
                    };

                    updateFormData({
                        ...updates,
                        item: selectJobRate ? value : ''
                    });

                    // if (!selectJobRate) {
                    //     alert('For this Item Job Rate is not Defined');
                    // }
                    // Filter and process average values
                    const selectPanna = itemAvglist?.data?.filter(val => val.itemId === value);
                    const selectAvg = selectPanna?.filter(val => val.avg !== '0');
                    const selectm1Avg = selectPanna?.filter(val => val.avg1 !== '0');
                    const selectm2Avg = selectPanna?.filter(val => val.avg2 !== '0');
                    const selectm3Avg = selectPanna?.filter(val => val.avg3 !== '0');

                    // Determine unique sizes
                    const uniquePannasizes = [...new Set(selectAvg?.map(val => val.panna_size))];
                    const uniqueM1Pannasizes = [...new Set(selectm1Avg?.map(val => val.panna_size))];
                    const uniqueM2Pannasizes = [...new Set(selectm2Avg?.map(val => val.panna_size))];
                    const uniqueM3Pannasizes = [...new Set(selectm3Avg?.map(val => val.panna_size))];

                    // Filter cloth data based on sizes
                    const filterCloth = clothlist?.data?.filter(val => uniquePannasizes?.includes(val.panna_size));
                    const filterM1Cloth = clothlist?.data?.filter(val => uniqueM1Pannasizes?.includes(val.panna_size));
                    const filterM2Cloth = clothlist?.data?.filter(val => uniqueM2Pannasizes?.includes(val.panna_size));
                    const filterM3Cloth = clothlist?.data?.filter(val => uniqueM3Pannasizes?.includes(val.panna_size));

                    // Update cloth data
                    setClothdata(filterCloth);
                    setM1Clothdata(filterM1Cloth);
                    setM2Clothdata(filterM2Cloth);
                    setM3Clothdata(filterM3Cloth);

                    // Update matching options
                    const newMatching = [];
                    if (filterM1Cloth.length > 0) newMatching.push({ label: 'Matching 1', value: '1' });
                    if (filterM2Cloth.length > 0) newMatching.push({ label: 'Matching 2', value: '2' });
                    if (filterM3Cloth.length > 0) newMatching.push({ label: 'Matching 3', value: '3' });

                    // Set matching state
                    setMatching(newMatching);

                }
                break;

            case 'match':
                const selectedValue = parseInt(value, 10);
                updateRows(selectedValue);
                break;

            case 'patMatch':
                if (value) {
                    const selectPat = patmatchlist?.data?.find(item => item.ID === value);
                    setFormData(prev => ({
                        ...prev,
                        avg: selectPat?.avg
                    }));
                }
                break;

            case 'priceList':
                if (pricelist?.data?.length > 0) {
                    const selectPrice = pricelist?.data?.find(val => val.ID === value);
                    if (selectPrice) {
                        updateFormCopy('priceNm', selectPrice?.grpNm);
                        updateFormCopy('firm', selectPrice?.firmPer);
                        updateFormCopy('mrp', selectPrice?.mrpPer);
                    }
                }
                break;

            case 'partyId':
                if (partylist?.data?.length > 0) {
                    const selectParty = partylist?.data?.find(val => val.ID === value);
                    if (selectParty) {
                        updateFormCopy('partyNm', selectParty?.partyNm);
                        setFormData(prev => ({
                            ...prev,
                            scrPer: selectParty?.scrPer,
                            milPer: selectParty?.milPer,
                            retailerPer: selectParty?.retailerPer,
                            mrpPer: selectParty?.mrpPer,
                            groupId: selectParty?.groupId,
                        }));
                        // console.log(selectParty);
                    }
                }
                break;

            case 'firm':
                if (firmlist?.data?.length > 0) {
                    const selectfirm = firmlist?.data?.find(val => val.ID === value);
                    if (selectfirm) {
                        updateFormCopy('firmNm', selectfirm?.firmNm);
                    }
                }
                break;

            case 'schl':
                if (schlList?.data?.length > 0) {
                    const selectSchool = schlList?.data?.find(val => val.ID === value);
                    if (selectSchool) {
                        updateFormCopy('schlNm', selectSchool?.schoolNm);
                    }
                }
                break;

            default:
                break;
        }

        // Update form data with the selected dropdown value
        updateFormData({ [dropdownType]: value });
    };

    const updateRows = (matchCount) => {
        const newRows = clothTypes.slice(0, matchCount + 1).map(type => ({
            clothTypes: type,
            cloth: '',
            rate: '0',
            panna: '0',
        }));
        setRows(newRows);
    };

    const handleNavitoItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleNavitoParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleNavitoSchool = () => {
        window.open(`/NewSchoolEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };
    const handleNavitoSalesman = () => {
        window.open(`/NewSalesmanEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };
     const handleNavitogr = () => {
        window.open(`/NewGuaranteerEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };
    const handleNavitobrand = () => {
        window.open(`/new-brand-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleNavitoCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleNavigateToPatternMatch = () => {
        window.open(`/pattern-matching-new`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavitoRetailer = () => {
        window.open(`/retailer-entry-new`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleNavigateItemAvg = () => {
        window.open(`/new-item-avg-entry`, '_blank', 'width=1000,height=1000,scrollbars=yes,resizable=yes');
    };

    const handleSizeWiseView = (id) => {
        window.open(`/sizewise-material-view/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handlePatternMatchAdd = () => {
        if (formData.item === '') {
            alert('Select Item');
        } else {
            fetchItemJobRate(formData.item);
            const selectPmId = patmatchlist?.data?.find(item => item.ID === formData.patMatch);
            const updatedPattern = [...patternMatch];
            const exists = updatedPattern?.some(item => item.pmId === selectPmId?.pmId);
            if (exists) {
                alert("Pattern already added!");
                return;
            } else {
                const selectPattern = patmatchlist?.data?.find(item => item.ID === formData.patMatch);
                var data = {
                    pmId: selectPattern?.ID,
                    patMatch: selectPattern?.patMatch,
                    avg: selectPattern?.avg,
                    panna: selectPattern?.panna,
                    type: ''
                };

                if (updatedPattern?.length <= 2) {
                    const len = updatedPattern?.length + 1;
                    updateRows(len);

                    const val = clothTypes.slice(0, len + 1);
                    if (val[val.length - 1]?.includes('Matching Cloth-1')) {
                        const filterM1Cloths = clothlist?.data?.filter(item => item.panna_size === selectPattern?.panna);
                        setM1Clothdata(filterM1Cloths);
                        data.type = 'Matching Cloth-1';
                    } else if (val[val.length - 1]?.includes('Matching Cloth-2')) {
                        const filterM2Cloths = clothlist?.data?.filter(item => item.panna_size === selectPattern?.panna);
                        setM2Clothdata(filterM2Cloths);
                        data.type = 'Matching Cloth-2';
                    } else if (val[val.length - 1]?.includes('Matching Cloth-3')) {
                        const filterM3Cloths = clothlist?.data?.filter(item => item.panna_size === selectPattern?.panna);
                        setM3Clothdata(filterM3Cloths);
                        data.type = 'Matching Cloth-3';
                    }

                }

                setPatternMatch(prev => [...prev, data]);

                setFormData(prev => ({
                    ...prev,
                    patMatch: '',
                    avg: '',
                    avgType: '0'
                }));
            }
        }

    };

    const getFilteredClothData = (clothType) => {
        switch (clothType) {
            case 'Main Cloth':
                return clothdata;
            case 'Matching Cloth-1':
                return m1clothdata;
            case 'Matching Cloth-2':
                return m2clothdata;
            case 'Matching Cloth-3':
                return m3clothdata;
            default:
                return [];
        }
    };


    const handleDropdownChanged = (event, value, index, fieldName) => {
        // If fieldName is 'cloth', find the rate from clothlist
        if (fieldName === 'cloth' && value) {
            // Find the selected cloth in clothlist
            const selectedCloth = clothlist.data.find(cloth => cloth.ID === value.ID); // value is the selected object
            // Get the rate and panna size for the selected cloth
            const rate = selectedCloth ? selectedCloth.rate : 0;
            const panna = selectedCloth ? selectedCloth.panna_size : 0;

            const updatedRows = rows.map((row, i) =>
                i === index ? { ...row, [fieldName]: value.ID, rate, panna } : row
            );
            setRows(updatedRows);
        } else {
            // Handle other field names if necessary
            const updatedRows = rows.map((row, i) =>
                i === index ? { ...row, [fieldName]: value } : row
            );
            setRows(updatedRows); // Update rows state
        }
    };

    const handleInputChanged = (event, index) => {
        const { value, name } = event.target;
        // Update the row data based on index and name (e.g., 'rate')
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [name]: value } : row
        );
        setRows(updatedRows); // Assume setRows updates your rows state
    };

    const handleJobrateChange = (e) => {
        const { name, value } = e.target;

        // first update temp object
        const updated = {
            ...jobrate,
            [name]: value
        };

        // calculate total outside setJobrate
        const total =
            Number(updated.ctoutex || 0) +
            Number(updated.stoutex || 0) +
            Number(updated.proutex || 0) +
            Number(updated.kjoutex || 0) +
            Number(updated.embriadaryex || 0) +
            Number(updated.screenex || 0) +
            Number(updated.printex || 0) +
            Number(updated.mtex || 0) +
            Number(updated.extex || 0);

        updated.totex = total.toFixed(2);

        /// now set one time
        setJobrate(updated);

        setFormData(prev => ({
            ...prev,
            jobrate: Math.round(parseFloat(prev.oldjobrate) + total)
        }));
    };

    function convertIntoOneObject(array, formData, formCopy, clothlist, patternMatch, jobrate, selectedMaterials, itemIndex) {
        if (!array || array.length === 0) {
            console.error("Array is missing or empty:", array);
            return null; // Return null or handle the error appropriately
        }

        const main_Avgs = array.map((_, index) => {
            return itemAvglist?.data?.filter((val) => val.itemId === formData.item && val.panna_size === (array[index]?.panna || '')) || [];
        });
        const patternNm = patternMatch?.map(item => item.patMatch).join('-');

        const itemnm = `${formCopy.itemNm} - ${patternNm}  ${formData.emb} ${formData.logo}`;

        // Initialize tableData with formData fields
        const tableData = {
            dt: formData.dt || '',
            priceList: formData.priceList || '',
            item: formData.item || '',
            schl: formData.schl || '',
            jobrate: formData.jobrate || '',
            extra: formData.extra || '',
            outSrc: formData.outSrc || '',
            nar: formData.naration || '',
            size: formData.size?.split(',') || '',
            userId: formData.userId || '',
            firmNm: formCopy.firmNm || '',
            partyNm: formCopy.partyNm || '',
            priceNm: formCopy.priceNm || '',
            itemNm: itemnm || '',
            //  qtNo:formData.quotNo,
            //qtNo: Number(formData.quotNo) + Number(itemIndex),
            qtNo: formData.quotType === "0" ? Number(formData.quotNo) + Number(itemIndex) : formData.quotNo,
            schlNm: formCopy.schlNm || '',
            firmPer: formCopy.firm || '',
            mrp: formCopy.mrp || '',
            // profit: formData.profit || 0,
            scrTomil: formData.scrTomil || 0,
            milToparty: formData.milToparty || 0,
            loss: formData.loss || 0,
            patternMatch: patternMatch,
            jobrateArr: jobrate,
            materialArr: selectedMaterials,
            scrPer: formData.scrPer,
            milPer: formData.milPer,
            retailerPer: formData.retailerPer,
            mrpPer: formData.mrpPer,
            groupId: formData.groupId,
            embval: formData.emb,
            logoval: formData.logo
        };

        // Helper function to get clothNm by cloth ID
        const getClothNmById = (clothId) => {
            const cloth = clothlist.data.find(cloth => cloth.ID === clothId);
            return cloth ? `${cloth.clothNm} ${cloth.model} ${cloth.color} ${cloth.shadeNo}` : '';
        };

        // Iterate over each array element and populate tableData
        for (let index = 0; index < array.length; index++) {
            const item = array[index];
            const clothValue = item.cloth || 0;
            const rateValue = item.rate || 0;

            // Check for invalid values in cloth and rate fields
            if ((clothValue === '0' || rateValue === '0') || rateValue === " ") {
                if (index === 0) {
                    alert('Enter main cloth rate');
                } else {
                    alert(`Enter Matching-${index} cloth rate`);
                }

                return; // Exit the function early if invalid data is found
            }

            tableData[`m${index}`] = clothValue;
            tableData[`m${index}rate`] = rateValue;
            tableData[`m${index}_panna`] = item.panna || 0;
            tableData[`m${index}clothNm`] = getClothNmById(item.cloth); // Lookup clothNm

            const main_Avg = main_Avgs[index];
            // console.log(main_Avg);

            const selectM1Pattern = patternMatch?.find(item => item.type === "Matching Cloth-1");
            const selectM2Pattern = patternMatch?.find(item => item.type === "Matching Cloth-2");
            const selectM3Pattern = patternMatch?.find(item => item.type === "Matching Cloth-3");

            tableData[`m${index}_avg`] = main_Avg.map((val) => ({
                avg: val.avg,
                size: val.size
            })) || [];
            tableData[`m${index}_avg1`] = main_Avg.map((val) => ({
                avg1: selectM1Pattern ? selectM1Pattern?.avg : val.avg1,
                size: val.size
            })) || [];
            tableData[`m${index}_avg2`] = main_Avg.map((val) => ({
                avg2: selectM1Pattern ? selectM2Pattern?.avg : val.avg2,
                size: val.size
            })) || [];
            tableData[`m${index}_avg3`] = main_Avg.map((val) => ({
                avg3: selectM1Pattern ? selectM3Pattern?.avg : val.avg3,
                size: val.size
            })) || [];
        };


        return tableData;
    }
    // console.log(patternMatch)
    const handleAdd = () => {

        if (!formData.firm || formData.firm.trim() === "") {
            alert("Select Firm");
        } else if (!formData.partyId || formData.partyId.trim() === "") {
            alert("Select Party");
        } else if (!formData.item || formData.item.trim() === "") {
            alert("Select Item");
        } else if (!formData.jobrate || String(formData.jobrate).trim() === "") {
            alert("Enter Jobrate");
        } else {
            // Convert form data and array into one object
            const itemIndex = formArray.length;

            const newEntry = convertIntoOneObject(rows, formData, formCopy, clothlist, patternMatch, jobrate, selectedMaterials, itemIndex);
            if (newEntry !== undefined) {
                // Add the converted object to formArray
                setFormArray((prevArray) => [...prevArray, newEntry]);
                // Reset form data after adding
                setFormData(prev => ({
                    ...prev,
                    // quotType: '0',
                    priceList: '',
                    item: '',
                    jobrate: '',
                    extra: '0',
                    outSrc: '0',
                    naration: '-',
                    match: '',
                    profit: '',
                    scrTomil: '0',
                    milToparty: '0',
                    loss: '',
                    avgType: '0',
                    scrPer: '0',
                    mrpPer: "0",
                    milPer: "0",
                    retailerPer: "0",
                    groupId: '',
                    emb: '',
                    logo: '',
                }));
                // Reset rows to default values
                setRows([{
                    clothTypes: 'Main Cloth',
                    cloth: '',
                    rate: '0',
                    panna: '0'
                }]);
                setItemMaterials([]);
                setPatternMatch([]);
                setJobrate({
                    ctex: '',
                    stex: '',
                    prex: '',
                    kjex: '',
                    mtex: '',
                    extex: '',
                    totex: '',
                    conex: ''
                });
                setSelectedMaterials([]);
            }
        }
    };

    const handleRemoveSelected = () => {
        setFormArray(prevFormArray =>
            prevFormArray.filter((_, index) => !selectedRows.has(index))
        );
        setSelectedRows(new Set()); // Clear selection after removal
    };


    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        // const url = `/QuotationView?form=${encodeURIComponent(JSON.stringify(form))}`;
        // store object in localStorage
        localStorage.setItem("viewFormData", JSON.stringify(form));

        // Open the URL in a new tab
        window.open('/QuotationView', '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    // const handleCheckboxChange = (index) => {
    //     setSelectedRows(prevSelectedRows => {
    //         const newSelectedRows = new Set(prevSelectedRows);
    //         if (newSelectedRows.has(index)) {
    //             newSelectedRows.delete(index);
    //         } else {
    //             newSelectedRows.add(index);
    //         }
    //         return newSelectedRows;
    //     });
    // };
    const handleCheckboxChange = (index) => {
        const newSelected = new Set(selectedRows);

        if (newSelected.has(index)) {
            newSelected.delete(index);
        } else {
            newSelected.add(index);

            // Set quotation number in formData
            const selectedForm = formArray[index];

            setFormData(prev => ({
                ...prev,
                quotNo: selectedForm.quotNo
            }));
        }

        setSelectedRows(newSelected);
    };
    const handleCheckboxMaterialChange = (material) => {
        setSelectedMaterials(prev => {
            const exists = prev.some(m => m.ID === material.ID);

            if (exists) {
                return prev.filter(m => m.ID !== material.ID); // remove
            } else {
                return [...prev, material]; // add full object
            }
        });
    };



    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
    ];

    const quotoptions = [
        { label: 'Auto', value: "0" },
        { label: 'Manual', value: "1" }
    ];

    const quotNofields = [
        { label: 'Quotation No', name: 'quotNo' },
    ];

    const dropdownlist = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data || [],
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },

        },
        {
            label: 'Party',
            id: 'partyId',
            options: partylist?.data2 || [],
            value: formData.partyId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitoParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('partyId'),
            handleDropdownClose: () => handleDropdownClose('partyId'),
        },
        {
            label: 'Retailer',
            id: 'retailerId',
            options: retailerlist?.data || [],
            value: formData.retailerId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'retailerId', value: newValue ? newValue.ID : '' } }, 'retailerId'),
            getOptionLabel: (option) => option.retailerNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitoRetailer(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('retailerId'),
            handleDropdownClose: () => handleDropdownClose('retailerId'),
        },
        {
            label: 'School',
            id: 'schl',
            options: schlList?.data || [],
            value: formData.schl,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schl', value: newValue ? newValue.ID : '' } }, 'schl'),
            getOptionLabel: (option) => option.schoolNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitoSchool(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('schl'),
            handleDropdownClose: () => handleDropdownClose('schl'),
        },
        {
            label: 'Salesman',
            id: 'salesmanId',
            options: salesmanlist?.data || [],
            value: formData.salesmanId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'salesmanId', value: newValue ? newValue.ID : '' } }, 'salesmanId'),
            getOptionLabel: (option) => option.name || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitoSalesman(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('salesmanId'),
            handleDropdownClose: () => handleDropdownClose('salesmanId'),
        },
        {
            label: 'Guaranteer',
            id: 'grId',
            options: grlist?.data || [],
            value: formData.grId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'grId', value: newValue ? newValue.ID : '' } }, 'grId'),
            getOptionLabel: (option) => option.name || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitogr(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('grId'),
            handleDropdownClose: () => handleDropdownClose('grId'),
        },
        {
            label: 'Brand',
            id: 'brandId',
            options: brandlist?.data || [],
            value: formData.brandId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'brandId', value: newValue ? newValue.ID : '' } }, 'brandId'),
            getOptionLabel: (option) => option.brandNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitobrand(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('brandId'),
            handleDropdownClose: () => handleDropdownClose('brandId'),
        },
        {
            label: 'Item',
            id: 'item',
            options: itemlist?.data || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitoItem(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('item'),
            handleDropdownClose: () => handleDropdownClose('item'),
        },
        {
        label: 'Embroidery Type',
        id: 'embType',
        options: [
            { label: 'Screen', value: 'Screen' },
            { label: 'Digital', value: 'Digital' }
        ],
        value: formData.embType,
        onChange: (newValue) =>
            handleDropdownChange(
                { target: { name: 'embType', value: newValue ? newValue.value : '' } },
                'embType'
            ),
        getOptionLabel: (option) => option.label || '',
        isOptionEqualToValue: (option, value) => option.value === value.value,
        valueFinder: (options, value) => {
            if (Array.isArray(options)) {
                return options.find(item => item.value === value) || null;
            }
            return null;
        }
    }

    ];

    const fields2 = [
        { label: 'Jobrate', name: 'jobrate' },
        { label: 'Extra', name: 'extra' },
        { label: 'Out Source(+)%', name: 'outSrc' },
        // { label: 'Profit %', name: 'profit' },
        // { label: 'SCR TO MIL %', name: 'scrTomil' },
        // { label: 'MIL TO Party %', name: 'milToparty' },
        { label: 'Value of Loss%', name: 'loss' },
        { label: 'Group ID', name: 'groupId' },
        { label: 'Embroidary', name: 'emb' },
        { label: 'Logo', name: 'logo' },
        { label: 'Age Group', name: 'agegroup' },
    ];

    const fields3 = [
        { label: 'Avg', name: 'avg', btnlabel: 'Add', handleAddNew: handlePatternMatchAdd },
    ];

    const naration = {
        label: 'Naration',
        name: 'naration',
        onchange: handleInputChange,
        isDesktop: true
    };

    const dropdownNoMatch = [
        {
            label: 'No of Matching',
            id: 'match',
            options: matching || [],
            value: formData.match,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'match', value: newValue ? newValue.value : '' } }, 'match'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.value === value.value,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.value === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateItemAvg(),
            btnlabel: 'Item Avg',

        },
    ];
    const dropdownEmbroidery = [
{
    label: 'Embroidery',
    id: 'embroidery',
    options: [
        { label: 'Screen', value: 'Screen' },
        { label: 'Digital', value: 'Digital' }
    ],
    value: formData.embroidery,
    onChange: (newValue) =>
        handleDropdownChange(
            { target: { name: 'embroidery', value: newValue ? newValue.value : '' } },
            'embroidery'
        ),
    getOptionLabel: (option) => option.label || '',
    isOptionEqualToValue: (option, value) => option.value === value.value,
    valueFinder: (options, value) => {
        if (Array.isArray(options)) {
            return options.find(item => item.value === value) || null;
        }
        return null;
    }
}
];

    const avgTypes = [
        { label: 'Yes', value: "1" },
        { label: 'No', value: "0" }
    ];

    const dropdownPatternMatch = [
        {
            label: 'Pattern Matching',
            id: 'patMatch',
            options: patmatchlist?.data || [],
            value: formData.patMatch,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'patMatch', value: newValue ? newValue.ID : '' } }, 'patMatch'),
            getOptionLabel: (option) => `${option.patMatch}-${option.panna}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateToPatternMatch(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('patMatch'),
            handleDropdownClose: () => handleDropdownClose('patMatch'),
        },
    ];


    function conintoObject2(formData, formArray) {
        const data = {
            quotNo: formData.quotNo,
            quotType: formData.quotType,
            quotationNo: formData.quotationNo,
            embType:formData.embType,
            salesmanId:formData.salesmanId,
            grId:formData.grId,
            brandId:formData.brandId,
            dt: formData.dt,
            agegroup:formData.agegroup,
            firm: formData.firm,
            partyId: formData.partyId,
            retailerId: formData.retailerId,
            userId: formData.userId,
            itemData: formArray
        }
        return data;
    };

    // console.log(selectedMaterials);

    // console.log(formArray)


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.firm === '') {
            alert('Select Firm');
        } else if (formData.partyId === '') {
            alert('Select Party');
        } else {
            setLoading(true);

            try {

                const finalObj = conintoObject2(formData, formArray);
                console.log("finalobj=>",finalObj);

                const result = await dispatch(createQuotationEntry(finalObj)).unwrap();
                // console.log('POST request successful!', result);
                // toast.success("Quotation Added");
                alert("Quotation Added");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
                // after submit delete localStorage
                localStorage.removeItem("viewFormData");
            }
        }


    };
    return (
        <>
            <Titlebar data={QuotationMaster} />
            <div style={{ margin: '1%' }}>
                <h2>Quotation Entry</h2>
                <Grid container>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>

                            <Grid container spacing={1.2}>


                                {fields?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <RadioComponent
                                    label='Quot.ItemNo.Type'
                                    name='quotType'
                                    value={formData.quotType}
                                    options={quotoptions}
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                />

                                {quotNofields?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    dropdownlist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {patternMatch?.length <= 2 &&
                                    <>
                                        <RadioComponent
                                            label='Avg. Type'
                                            name='avgType'
                                            value={formData.avgType}
                                            options={avgTypes}
                                            isDesktop={isDesktop}
                                            onChange={handleRadioChange}
                                        />

                                        {
                                            formData.avgType === '1' && dropdownPatternMatch?.map((drop) => (
                                                <DropdownWithBtn
                                                    key={drop.label}
                                                    label={drop.label}
                                                    id={drop.id}
                                                    options={drop.options}
                                                    value={drop.value}
                                                    onChange={drop.onChange}
                                                    isDesktop={isDesktop}
                                                    getOptionLabel={drop.getOptionLabel}
                                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                                    valueFinder={drop.valueFinder}
                                                    handleAddNew={drop.handleAddNew}
                                                    btnlabel={drop.btnlabel}
                                                    handleDropdownOpen={drop.handleDropdownOpen}
                                                    handleDropdownClose={drop.handleDropdownClose}
                                                />
                                            ))
                                        }


                                        {formData.avgType === '1' && fields3?.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                btnlabel={field.btnlabel}
                                                handleAddNew={field.handleAddNew}
                                            />
                                        ))}
                                    </>

                                }


                                {fields2?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    naration &&
                                    <TextareaComponent
                                        label={naration.label}
                                        name={naration.name}
                                        value={formData[naration.name]}
                                        onChange={naration.onchange}
                                        isDesktop={naration.isDesktop}
                                    />
                                }


                                {
                                    formData.avgType === '0' && patternMatch?.length <= 2
                                    && dropdownNoMatch?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                        />
                                    ))
                                }

                                {formData.avgType === '1' &&
                                    <Grid item xs={6}>

                                    </Grid>}

                                <Grid item xs={12}>
                                    <h3>Cloth Details</h3>
                                    <TableContainer style={{
                                        width: isDesktop ? '100%' : '100%',
                                        marginLeft: isDesktop ? '0%' : '0%',
                                        overflow: 'hidden'
                                    }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth Type</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000', width: '300px' }} align='center'>Cloth</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.length > 0 ?
                                                    (rows?.map((row, index) => {
                                                        const filteredClothData = getFilteredClothData(row.clothTypes);
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.clothTypes}
                                                                </TableCell>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', display: 'flex', alignItems: 'center', gap: 0.4 }} align='center'>
                                                                    <Autocomplete
                                                                        id="cloth"
                                                                        options={filteredClothData}
                                                                        getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || ''}
                                                                        value={filteredClothData.find(item => item.ID === row.cloth) || null}
                                                                        onChange={(e, newValue) => handleDropdownChanged(e, newValue, index, 'cloth')} // Pass newValue as the selected object
                                                                        onOpen={() => handleDropdownOpen('cloth')}
                                                                        onClose={() => handleDropdownClose('cloth')}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                placeholder='Select Option'
                                                                                sx={{
                                                                                    ...inputStyless,
                                                                                    '& .MuiInputBase-root': {
                                                                                        height: '35px',
                                                                                    },
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={handleNavitoCloth}
                                                                        size='small'

                                                                    >
                                                                        New
                                                                    </Button>

                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <TextField
                                                                        name='rate'
                                                                        value={row.rate}
                                                                        onChange={(e) => handleInputChanged(e, index)}
                                                                        inputProps={{ style: styled.inputs }}
                                                                        sx={inputNumbers}
                                                                    />

                                                                </TableCell>

                                                            </TableRow>
                                                        )
                                                    }
                                                    )) : ''}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {patternMatch?.length > 0 && <div>
                                        <h3>Pattern Matching</h3>
                                        <table>
                                            <thead>
                                                <th>Sr.No.</th>
                                                <th>Pattern Match</th>
                                                <th>Panna</th>
                                                <th>Avg.</th>
                                            </thead>

                                            <tbody>
                                                {
                                                    patternMatch?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.patMatch}</td>
                                                            <td>{item.panna}</td>
                                                            <td>{item.avg}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>

                                    </div>}


                                    {/* 
                                    {patternMatch?.length > 0 &&
                                        <div>
                                            <h3>Pattern Matching</h3>
                                            <table>
                                                <thead>
                                                    <th>Sr.No.</th>
                                                    <th>Pattern Match</th>
                                                    <th>Panna</th>
                                                    <th>Avg.</th>
                                                </thead>

                                                <tbody>
                                                    {
                                                        patternMatch?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.patMatch}</td>
                                                                <td>{item.panna}</td>
                                                                <td>{item.avg}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>

                                            <h3>Job Rate</h3>
                                            <table>
                                                <thead>
                                                    <th>Cutting-In</th>
                                                    <th>Cutting-Out</th>
                                                    <th>Stitching-In</th>
                                                    <th>Stitching-Out</th>
                                                    <th>Kaje-In</th>
                                                    <th>Kaje-Out</th>
                                                    <th>Press-In</th>
                                                    <th>Press-Out</th>
                                                    <th>Embroidery</th>
                                                    <th>Screen</th>
                                                    <th>Print</th>
                                                    <th>Extra</th>
                                                    <th>Material</th>
                                                    <th>Total</th>
                                                    <th>Cut To Pack</th>
                                                    <th>Stitch To Pack</th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{jobrate?.cut_in}</td>
                                                        <td>{jobrate?.cut_out}</td>
                                                        <td>{jobrate?.stitch_in}</td>
                                                        <td>{jobrate?.stitch_out}</td>
                                                        <td>{jobrate?.kaje_in}</td>
                                                        <td>{jobrate?.kaje_out}</td>
                                                        <td>{jobrate?.press_in}</td>
                                                        <td>{jobrate?.press_out}</td>
                                                        <td>{jobrate?.embriadary}</td>
                                                        <td>{jobrate?.screen}</td>
                                                        <td>{jobrate?.print}</td>
                                                        <td>{jobrate?.extra}</td>
                                                        <td>{jobrate?.material}</td>
                                                        <td>{jobrate?.total}</td>
                                                        <td>{jobrate?.cut_to_pack}</td>
                                                        <td>{jobrate?.stitch_to_pack}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><input type="text" name="ctinex" value={jobrate.ctinex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="ctoutex" value={jobrate.ctoutex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="stinex" value={jobrate.stinex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="stoutex" value={jobrate.stoutex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="kjinex" value={jobrate.kjinex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="kjoutex" value={jobrate.kjoutex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="prinex" value={jobrate.prinex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="proutex" value={jobrate.proutex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="embriadaryex" value={jobrate.embriadaryex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="screenex" value={jobrate.screenex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="printex" value={jobrate.printex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="extex" value={jobrate.extex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="mtex" value={jobrate.mtex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td>{jobrate.totex}</td>
                                                        <td><input type="text" name="cut_to_pack_ex" value={jobrate.cut_to_pack_ex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                        <td><input type="text" name="stitch_to_pack_ex" value={jobrate.stitch_to_pack_ex} onChange={handleJobrateChange} style={{ width: '40px' }} /></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={13} style={{ textAlign: "right" }}>Total</td>
                                                        <td>{formData.jobrate}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    } */}
                                </Grid>

                                {/* {itemMaterials?.length > 0 &&
                                    <Grid item xs={12} md={6}>
                                        <div>
                                            <h3>Material</h3>
                                            <table>
                                                <thead>
                                                    <th>Sr.No.</th>
                                                    <th>Material</th>
                                                    <th>View</th>
                                                </thead>

                                                <tbody>
                                                    {
                                                        itemMaterials?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedMaterials.some(m => m.ID === item.ID)}
                                                                        onChange={() => handleCheckboxMaterialChange(item)}
                                                                    />
                                                                    {" "}
                                                                    {index + 1}</td>
                                                                <td>{item.materialNm}</td>
                                                                <td>{item?.sizewise?.length > 0 ? <Preview className='cursor-pointer' onClick={() => handleSizeWiseView(item.ID)} /> : '-'}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>


                                        </div>
                                    </Grid>
                                } */}


                                <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <Button variant="contained" color="primary" onClick={handleAdd}>Add</Button>
                                    <Button variant="contained" color="error" onClick={handleRemoveSelected}>Delete</Button>
                                </Grid>
                                <Grid item xs={12} >
                                    {formArray.length > 0 &&
                                        <TableContainer

                                        >
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Select.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Quotation No</TableCell>

                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>View</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {formArray.length > 0
                                                        ? formArray.map((form, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows.has(index)}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.qtNo}</TableCell>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(form)} />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                        : ''}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }
                                </Grid>


                                {formArray?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>


        </>
    );
}

export default QuotEntry2;
